import { useStateManager } from 'components/context/StateManager'
import Trans from 'next-translate/Trans'
import { acceptOrderChance } from 'services/api'
import useTextDirection from 'utils/hooks/useTextDirection'

const LastChance: React.FC = () => {
  const [state, setState] = useStateManager()
  const dir = useTextDirection()

  if (!state.modal) {
    return <></>
  }

  const acceptLastChance = async () => {
    await acceptOrderChance()
    setState({ ...state, modal: '', chance: true })
  }

  return (
    <>
      <div dir={dir} className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none max-w-sm mx-auto focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <div className="border-0 font-helvetica rounded-lg shadow-lg relative flex flex-col justify-center w-full bg-white outline-none focus:outline-none">
            <img
              className="block mx-auto mt-10 w-20 h-16"
              src="/assets/o_series/checkout/warning.svg"
            />
            <div className="relative py-6 px-4 flex-auto text-center">
              <p className="text-tundora text-xl font-bold leading-relaxed">
                <Trans
                  i18nKey="o_series/survey/app:app.18-checkout.last_chance_modal.title"
                  components={[
                    <span key="highlight" className="text-green-200" />,
                  ]}
                />
              </p>
            </div>
            <button
              className="block mx-auto btn mt-4 mb-10 max-w-xs text-lg py-2 px-4"
              onClick={() => acceptLastChance()}
            >
              <Trans i18nKey="o_series/survey/app:app.18-checkout.last_chance_modal.button" />
            </button>
          </div>
        </div>
      </div>
      <div className="opacity-50 fixed inset-0 z-40 bg-black"></div>
    </>
  )
}

export default LastChance
